import { Attribute } from "@api/types/course-completion";

export function getAttribute(attributes: Attribute[], attribute: string) {
  let returnAttribute = attributes.find((a) => a.code === attribute);

  if (returnAttribute?.value === undefined) {
    return "";
  }

  return returnAttribute.value ? returnAttribute.value : "";
}
